<!-- Modal Overlay -->
<div class="bk-modal-overlay" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">

    <h2 class="modal-title">Almost Registered!</h2>

    <!-- Error Message -->
    <div *ngIf="error" class="modal-error">{{ error }}</div>

    <!-- Loading / Checking Call Plan -->
    <div *ngIf="checkingCallPlan" class="text-center">
      <p>Verifying your information...</p>
    </div>

    <!-- Call Plan Confirm Dialog -->
    <div *ngIf="confirmDialogVisible && callPlanData">
      <div class="callplan-confirm">
        <h3>Is this you?</h3>
        <p><strong>{{ callPlanData.first_name }} {{ callPlanData.last_name }}</strong></p>
        <p *ngIf="callPlanData.city || callPlanData.state">{{ callPlanData.city }}, {{ callPlanData.state }}</p>
        <div class="bk-modal-actions">
          <button class="btn btn-outlined" (click)="cancelCallPlan()">No, that's not me</button>
          <button class="btn btn-primary" (click)="confirmCallPlan()">Yes, that's me</button>
        </div>
      </div>
    </div>

    <!-- Dynamic Questions Form -->
    <form
      *ngIf="useDynamicQuestions && !confirmDialogVisible && !loadingQuestions"
      [formGroup]="registrationForm"
      (submit)="onStep1Submit($event)"
      novalidate
    >
      <div *ngFor="let eq of registrationQuestions">
        <div
          *ngIf="eq.question && isQuestionVisible(eq)"
          class="form-group"
          [class.field-error]="isFieldMissing(getQuestionControlName(eq.question!.id))"
        >
          <!-- HEADER type -->
          <h4 *ngIf="resolveQuestionTypeId(eq.question) === 'HEADER'" class="question-header">{{ eq.question!.text }}</h4>

          <!-- PARAGRAPH type -->
          <p *ngIf="resolveQuestionTypeId(eq.question) === 'PARAGRAPH'" class="question-paragraph">{{ eq.question!.text }}</p>

          <!-- NPI # with N/A checkbox (TEXT_FIELD or NUMBER) -->
          <ng-container *ngIf="isNpiField(eq.question!.field_id) && (resolveQuestionTypeId(eq.question) === 'TEXT_FIELD' || resolveQuestionTypeId(eq.question) === 'NUMBER')">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <div class="npi-field-row">
              <input
                type="text"
                [formControlName]="getQuestionControlName(eq.question!.id)"
                [readonly]="isNpiNa(eq.question!.id)"
              />
              <label class="checkbox-label npi-na-label">
                <input
                  type="checkbox"
                  [checked]="isNpiNa(eq.question!.id)"
                  (change)="onNpiNaChange(eq, $event)"
                />
                N/A
              </label>
            </div>
          </ng-container>

          <!-- TEXT_FIELD (license/State License # is routed here by resolveQuestionTypeId) -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'TEXT_FIELD' && !isNpiField(eq.question!.field_id)">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <input type="text" [formControlName]="getQuestionControlName(eq.question!.id)" />
            <div *ngIf="eq.question!.confirm" class="form-group mt-16">
              <label class="form-label">Confirm {{ eq.question!.text }}</label>
              <input type="text" [formControlName]="'confirm_question_' + eq.question!.id"
                [class.error]="isFieldMissing('confirm_question_' + eq.question!.id)" />
              <span *ngIf="getConfirmError(eq)" class="error-message">{{ getConfirmError(eq) }}</span>
            </div>
          </ng-container>

          <!-- DROPDOWN (multiselect for degrees/specialties) -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'DROPDOWN' && (eq.question!.field_id === 'degrees' || eq.question!.field_id === 'specialties')">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <app-multi-select-chips
              [options]="getQuestionChoices(eq.question!)"
              [placeholder]="'Select ' + eq.question!.text.toLowerCase() + '...'"
              [formControlName]="getQuestionControlName(eq.question!.id)"
            ></app-multi-select-chips>
          </ng-container>

          <!-- DROPDOWN (standard) -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'DROPDOWN' && eq.question!.field_id !== 'degrees' && eq.question!.field_id !== 'specialties'">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <select [formControlName]="getQuestionControlName(eq.question!.id)">
              <option value="">Select...</option>
              <option *ngFor="let choice of getQuestionChoices(eq.question!)" [value]="choice">{{ choice }}</option>
            </select>
          </ng-container>

          <!-- MULTIPLE_RADIO -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'MULTIPLE_RADIO'">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <div class="radio-group">
              <label *ngFor="let choice of getQuestionChoices(eq.question!)" class="radio-label">
                <input type="radio" [formControlName]="getQuestionControlName(eq.question!.id)" [value]="choice" />
                {{ choice }}
              </label>
            </div>
          </ng-container>

          <!-- MULTIPLE_CHECK (multiselect chips for degrees/specialties) -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'MULTIPLE_CHECK' && (eq.question!.field_id === 'degrees' || eq.question!.field_id === 'specialties')">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <app-multi-select-chips
              [options]="getQuestionChoices(eq.question!)"
              [placeholder]="'Select ' + eq.question!.text.toLowerCase() + '...'"
              [formControlName]="getQuestionControlName(eq.question!.id)"
            ></app-multi-select-chips>
          </ng-container>

          <!-- MULTIPLE_CHECK (standard) -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'MULTIPLE_CHECK' && eq.question!.field_id !== 'degrees' && eq.question!.field_id !== 'specialties'">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <div class="checkbox-group">
              <label *ngFor="let choice of getQuestionChoices(eq.question!)" class="checkbox-label">
                <input
                  type="checkbox"
                  [checked]="isChoiceSelected(eq.question!.id, choice)"
                  (change)="onCheckboxChange(eq.question!.id, choice, $event)"
                />
                {{ choice }}
              </label>
            </div>
          </ng-container>

          <!-- CHECKBOX (single) -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'CHECKBOX'">
            <label class="checkbox-label">
              <input type="checkbox" [formControlName]="getQuestionControlName(eq.question!.id)" />
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
          </ng-container>

          <!-- TEXTAREA / COMMENTS -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'TEXTAREA' || resolveQuestionTypeId(eq.question) === 'COMMENTS'">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <textarea [formControlName]="getQuestionControlName(eq.question!.id)"></textarea>
          </ng-container>

          <!-- NUMBER -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'NUMBER' && !isNpiField(eq.question!.field_id)">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <input type="number" [formControlName]="getQuestionControlName(eq.question!.id)" />
          </ng-container>

          <!-- PHONE_NUMBER -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'PHONE_NUMBER'">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <input type="tel" [formControlName]="getQuestionControlName(eq.question!.id)" />
          </ng-container>

          <!-- DATE -->
          <ng-container *ngIf="resolveQuestionTypeId(eq.question) === 'DATE'">
            <label class="form-label">
              <span *ngIf="isQuestionRequired(eq)" class="required-marker">*</span>
              {{ eq.question!.text }}
            </label>
            <input type="date" [formControlName]="getQuestionControlName(eq.question!.id)" />
          </ng-container>
        </div>
      </div>

      <div class="modal-actions">
        <button type="button" class="btn btn-outlined modal-btn" (click)="onCancel()">Cancel</button>
        <button type="submit" class="btn btn-primary modal-btn" [disabled]="loading">
          {{ loading ? 'Submitting...' : 'Submit' }}
        </button>
      </div>
    </form>

    <!-- Hardcoded Form: Step 1 -->
    <form
      *ngIf="!useDynamicQuestions && !loadingQuestions && step === 1 && !confirmDialogVisible && !checkingCallPlan"
      [formGroup]="registrationForm"
      (submit)="onStep1Submit($event)"
      novalidate
    >
      <!-- First Name -->
      <div class="form-group" [class.field-error]="isFieldMissing('first_name')">
        <label class="form-label"><span class="required-marker">*</span>First Name</label>
        <input type="text" formControlName="first_name" />
      </div>

      <!-- Last Name -->
      <div class="form-group" [class.field-error]="isFieldMissing('last_name')">
        <label class="form-label"><span class="required-marker">*</span>Last Name</label>
        <input type="text" formControlName="last_name" />
      </div>

      <!-- HCP Status -->
      <div class="form-group" [class.field-error]="isFieldMissing('is_hcp')">
        <label class="form-label"><span class="required-marker">*</span>Are you a healthcare professional?</label>
        <div class="radio-group">
          <label *ngFor="let opt of hcpOptions" class="radio-label">
            <input type="radio" formControlName="is_hcp" [value]="opt.value" />
            {{ opt.label }}
          </label>
        </div>
      </div>

      <!-- NPI Number (HCP Licensed) -->
      <div class="form-group" *ngIf="isHcpLicensed">
        <label class="form-label">
          <span *ngIf="!npiNa" class="required-marker">*</span>NPI Number
        </label>
        <div class="npi-field-row">
          <input type="text" formControlName="cats_num" [readonly]="npiNa" />
          <label class="checkbox-label npi-na-label">
            <input type="checkbox" [checked]="npiNa" (change)="onHardcodedNpiNaChange($event)" />
            N/A
          </label>
        </div>
      </div>

      <!-- License State -->
      <div class="form-group" *ngIf="showHcpFields">
        <label class="form-label">License State</label>
        <select formControlName="license_state">
          <option value="">Select State...</option>
          <option *ngFor="let s of stateOptions" [value]="s">{{ s }}</option>
        </select>
      </div>

      <!-- State License Number -->
      <div class="form-group" *ngIf="showHcpFields">
        <label class="form-label">State License Number</label>
        <input type="text" formControlName="license" />
      </div>

      <!-- Degrees -->
      <div class="form-group" [class.field-error]="isFieldMissing('degrees')">
        <label class="form-label"><span class="required-marker">*</span>Credentials</label>
        <app-multi-select-chips
          [options]="degreeOptions"
          placeholder="Select credentials..."
          formControlName="degrees"
        ></app-multi-select-chips>
      </div>

      <div class="form-group" *ngIf="showDegreesOther">
        <label class="form-label">Other Credentials</label>
        <input type="text" formControlName="degrees_other" />
      </div>

      <!-- Specialty -->
      <div class="form-group" [class.field-error]="isFieldMissing('subspecialty')">
        <label class="form-label"><span class="required-marker">*</span>Specialty</label>
        <app-multi-select-chips
          [options]="specialtyOptions"
          placeholder="Select specialty..."
          formControlName="subspecialty"
        ></app-multi-select-chips>
      </div>

      <div class="form-group" *ngIf="showSubspecialtyOther">
        <label class="form-label">Other Specialty</label>
        <input type="text" formControlName="subspecialty_other" />
      </div>

      <!-- Contact Type -->
      <div class="form-group" [class.field-error]="isFieldMissing('contact_type')">
        <label class="form-label"><span class="required-marker">*</span>Contact Type</label>
        <select formControlName="contact_type">
          <option value="">Select...</option>
          <option *ngFor="let ct of contactTypeOptions" [value]="ct">{{ ct }}</option>
        </select>
      </div>

      <div class="form-group" *ngIf="showContactTypeOther">
        <label class="form-label">Other Contact Type</label>
        <input type="text" formControlName="contact_type_other" />
      </div>

      <div class="modal-actions">
        <button type="button" class="btn btn-outlined modal-btn" (click)="onCancel()">Cancel</button>
        <button type="submit" class="btn btn-primary modal-btn" [disabled]="loading">Next</button>
      </div>
    </form>

    <!-- Hardcoded Form: Step 2 -->
    <form
      *ngIf="!useDynamicQuestions && !loadingQuestions && step === 2 && !confirmDialogVisible && !checkingCallPlan"
      [formGroup]="registrationForm"
      (submit)="onStep2Submit($event)"
      novalidate
    >
      <ng-container formGroupName="office">
        <!-- Affiliation -->
        <div class="form-group">
          <label class="form-label">Affiliation</label>
          <input type="text" formControlName="affiliation" />
        </div>

        <!-- Address 1 -->
        <div class="form-group" [class.field-error]="isFieldMissing('office.address1')">
          <label class="form-label"><span class="required-marker">*</span>Address</label>
          <input type="text" formControlName="address1" />
        </div>

        <!-- Address 2 -->
        <div class="form-group">
          <label class="form-label">Address 2</label>
          <input type="text" formControlName="address2" />
        </div>

        <!-- City -->
        <div class="form-group" [class.field-error]="isFieldMissing('office.city')">
          <label class="form-label"><span class="required-marker">*</span>City</label>
          <input type="text" formControlName="city" />
        </div>

        <!-- State -->
        <div class="form-group" [class.field-error]="isFieldMissing('office.state')">
          <label class="form-label"><span class="required-marker">*</span>State</label>
          <select formControlName="state">
            <option value="">Select State...</option>
            <option *ngFor="let s of stateOptions" [value]="s">{{ s }}</option>
          </select>
        </div>

        <!-- Zip -->
        <div class="form-group" [class.field-error]="isFieldMissing('office.zip')">
          <label class="form-label"><span class="required-marker">*</span>Zip Code</label>
          <input type="text" formControlName="zip" />
        </div>

        <!-- Phone -->
        <div class="form-group">
          <label class="form-label">Phone</label>
          <input type="tel" formControlName="phone" />
        </div>

        <!-- Email -->
        <div class="form-group" [class.field-error]="isFieldMissing('office.email')">
          <label class="form-label"><span class="required-marker">*</span>Email</label>
          <input type="email" formControlName="email" />
        </div>
      </ng-container>

      <!-- Confirm Email -->
      <div class="form-group" [class.field-error]="isFieldMissing('confirm_email')">
        <label class="form-label"><span class="required-marker">*</span>Confirm Email</label>
        <input type="email" formControlName="confirm_email" />
      </div>

      <div class="modal-actions">
        <button type="button" class="btn btn-outlined modal-btn" (click)="onCancel()">Cancel</button>
        <button type="submit" class="btn btn-primary modal-btn" [disabled]="loading">
          {{ loading ? 'Submitting...' : 'Submit' }}
        </button>
      </div>
    </form>

    <!-- Loading Questions -->
    <div *ngIf="loadingQuestions" class="text-center">
      <p>Loading registration form...</p>
    </div>

  </div>
</div>
